export default __webpack_public_path__ + "static/media/icon-bin.b250ed4d.svg";